import OliverText from "@builder/components/general/OliverText";
import "./styles.scss";
import { useTranslation } from "react-i18next";
import { useAppDispatch } from "@builder/store/store";
import { ActionBuilderType } from "@builder/utils/actionBuilderHelpers";
import { setCurrent } from "@builder/store/slices/actionBuilderSlice";

interface ActionMenuItemProps {
    icon: string;
    title: string;
    active?: boolean;
    onClick?: () => void;
    noTranslate?: boolean;
    onDelete?: () => void;
}

const ActionMenuItem = ({ icon, title, onClick, active, noTranslate, onDelete }: ActionMenuItemProps) => {
    const { t } = useTranslation();
    const dispatch = useAppDispatch();

    const handleDeleteClick = (e: React.MouseEvent) => {
        e.stopPropagation();
        if (onDelete) {
            onDelete();
            dispatch(setCurrent({ tab: ActionBuilderType.START, id: null }));
        }
    };

    return (
        <div className={`action-menu-item-wrapper ${active ? "active" : ""}`} onClick={onClick}>
            <img src={icon} />
            <div className="action-menu-info">
                <OliverText text={noTranslate ? title : t("popup.actionBuilder." + title)} size="s" weight="medium-heavy" />
            </div>
            {onDelete && <img src={"./trash.svg"} className="action-menu-delete" onClick={handleDeleteClick} />}
        </div>
    );
};

export default ActionMenuItem;
